import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-banner-hsia';
const html = `
<div>
  <div class="banner-hsia">
    <div class="swiper">
      <div data-attribute="list-item" class="swiper-wrapper">
        <div data-attribute="item" class="swiper-slide">
          <a data-use-mobile="true" data-attribute="link-item" href="#" class="wrap-item">
            <div class="wrap-img">
              <img
                class="img-desktop"
                data-attribute="image-banner"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab103643d1c860d98eb877e.webp"
                alt=""
              />
              <img
                class="img-mobile"
                data-attribute="image-banner-mobile"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab102d0e21e71e7623380ca.webp"
                alt=""
              />
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</div>


`;
export default containerFuild(html, css, {
  topPadding: false,
  bottomPadding: false,
  enableContainerPage: false,
});
